export default __webpack_public_path__ + "static/media/smartphoneswhite_5.7bd3ea29.png";